/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { NotificationService, WaitingService } from '@gh/core-ui';
import { openInNewWindow } from '@gh/core-util';
import { PurchaseOrderStatus } from '@gh/supplier-shared-data';
import { isNil } from 'lodash';
import { SupplierPurchaseOrderListBusinessService } from '../../resources';
import * as i0 from "@angular/core";
import * as i1 from "../../resources";
import * as i2 from "@gh/core-ui";
import * as i3 from "@angular/router";
import * as i4 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i5 from "@angular/material/sort";
import * as i6 from "../../../common-external-shared/directives/ext-if-query.directive";
import * as i7 from "../../../common-external-shared/components/ext-load-tracker/ext-load-tracker.component";
import * as i8 from "@angular/flex-layout/flex";
import * as i9 from "@angular/material/table";
import * as i10 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table.directive";
import * as i11 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table-viewer.directive";
import * as i12 from "@angular/material/slide-toggle";
import * as i13 from "@angular/common";
import * as i14 from "@angular/material/button";
import * as i15 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-row.directive";
import * as i16 from "@angular/flex-layout/extended";
import * as i17 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-list.component";
import * as i18 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-scroll-for.directive";
import * as i19 from "@angular/material/card";
import * as i20 from "../../../core-mls/translation/translate.pipe";
import * as i21 from "../../../core-type/pipes/type-format.pipe";
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_delivery_date"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 21);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "typeFormat");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(2, 1, order_r15.deliveryDate, "ShortDate"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_status"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r16 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(order_r16.status);
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_office"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r17 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(order_r17.officeName);
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 22);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_purchase_order_number"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r18 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(order_r18.purchaseOrder);
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_14_Template(rf, ctx) { if (rf & 1) {
    var _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-header-cell", 24);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-slide-toggle", 25);
    i0.ɵɵlistener("change", function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_14_Template_mat_slide_toggle_change_4_listener($event) { i0.ɵɵrestoreView(_r20); var ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.toggleRejected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "lbl_show_rejected"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r11.showRejected);
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); var order_r21 = i0.ɵɵnextContext().$implicit; var ctx_r25 = i0.ɵɵnextContext(2); return ctx_r25.reject(order_r21); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_reject"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_2_Template(rf, ctx) { if (rf & 1) {
    var _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r30); var order_r21 = i0.ɵɵnextContext().$implicit; var ctx_r28 = i0.ɵɵnextContext(2); return ctx_r28.accept(order_r21); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_accept"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_3_Template(rf, ctx) { if (rf & 1) {
    var _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r33); var order_r21 = i0.ɵɵnextContext().$implicit; var ctx_r31 = i0.ɵɵnextContext(2); return ctx_r31.view(order_r21); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_view"));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 24);
    i0.ɵɵtemplate(1, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_1_Template, 3, 3, "button", 26);
    i0.ɵɵtemplate(2, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_2_Template, 3, 3, "button", 27);
    i0.ɵɵtemplate(3, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_button_3_Template, 3, 3, "button", 26);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r21 = ctx.$implicit;
    var ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isOrderPending(order_r21));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.isOrderPending(order_r21));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", order_r21.fileUrl);
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_header_row_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function SupplierPurchaseOrderListComponent_mat_table_5_mat_row_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row", 30);
} if (rf & 2) {
    var order_r34 = ctx.$implicit;
    var ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ghExtInfiniteRow", order_r34)("ngClass", ctx_r14.getRowClass(order_r34));
} }
function SupplierPurchaseOrderListComponent_mat_table_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 6);
    i0.ɵɵelementContainerStart(1, 7);
    i0.ɵɵtemplate(2, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_2_Template, 3, 3, "mat-header-cell", 8);
    i0.ɵɵtemplate(3, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_3_Template, 3, 4, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4, 10);
    i0.ɵɵtemplate(5, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_5_Template, 3, 3, "mat-header-cell", 8);
    i0.ɵɵtemplate(6, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_6_Template, 2, 1, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(7, 11);
    i0.ɵɵtemplate(8, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_8_Template, 3, 3, "mat-header-cell", 8);
    i0.ɵɵtemplate(9, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_9_Template, 2, 1, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(10, 12);
    i0.ɵɵtemplate(11, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_11_Template, 3, 3, "mat-header-cell", 13);
    i0.ɵɵtemplate(12, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_12_Template, 2, 1, "mat-cell", 14);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(13, 15);
    i0.ɵɵtemplate(14, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_cell_14_Template, 5, 4, "mat-header-cell", 16);
    i0.ɵɵtemplate(15, SupplierPurchaseOrderListComponent_mat_table_5_mat_cell_15_Template, 4, 3, "mat-cell", 17);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(16, SupplierPurchaseOrderListComponent_mat_table_5_mat_header_row_16_Template, 1, 0, "mat-header-row", 18);
    i0.ɵɵtemplate(17, SupplierPurchaseOrderListComponent_mat_table_5_mat_row_17_Template, 1, 2, "mat-row", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(8);
    i0.ɵɵproperty("dataSource", ctx_r0.dataSource)("tracker", _r2)("trackBy", ctx_r0.getOrderId);
    i0.ɵɵadvance(16);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns)("matHeaderRowDefSticky", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
} }
function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_29_Template(rf, ctx) { if (rf & 1) {
    var _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_29_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r42); var order_r36 = i0.ɵɵnextContext().$implicit; var ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.reject(order_r36); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_reject"));
} }
function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_30_Template(rf, ctx) { if (rf & 1) {
    var _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 29);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_30_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); var order_r36 = i0.ɵɵnextContext().$implicit; var ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.accept(order_r36); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_accept"));
} }
function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_31_Template(rf, ctx) { if (rf & 1) {
    var _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("click", function SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_31_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r48); var order_r36 = i0.ɵɵnextContext().$implicit; var ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.view(order_r36); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_view"));
} }
function SupplierPurchaseOrderListComponent_div_6_mat_card_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-card", 35);
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵelementStart(2, "div", 36);
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 38);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 36);
    i0.ɵɵelementStart(9, "div", 37);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 38);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 36);
    i0.ɵɵelementStart(15, "div", 37);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 39);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 36);
    i0.ɵɵelementStart(21, "div", 37);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 38);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "typeFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "mat-card-actions");
    i0.ɵɵelementStart(28, "div");
    i0.ɵɵtemplate(29, SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_29_Template, 3, 3, "button", 26);
    i0.ɵɵtemplate(30, SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_30_Template, 3, 3, "button", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(31, SupplierPurchaseOrderListComponent_div_6_mat_card_7_button_31_Template, 3, 3, "button", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var order_r36 = ctx.$implicit;
    var ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r35.getRowClass(order_r36));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 13, "lbl_office"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(order_r36.officeName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 15, "lbl_purchase_order"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(order_r36.purchaseOrder);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 17, "lbl_status"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r35.getRowClass(order_r36));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(order_r36.status);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 19, "lbl_delivery_date"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(26, 21, order_r36.deliveryDate, "ShortDate"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r35.isOrderPending(order_r36));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r35.isOrderPending(order_r36));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", order_r36.fileUrl);
} }
function SupplierPurchaseOrderListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    var _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "mat-slide-toggle", 25);
    i0.ɵɵlistener("change", function SupplierPurchaseOrderListComponent_div_6_Template_mat_slide_toggle_change_5_listener($event) { i0.ɵɵrestoreView(_r50); var ctx_r49 = i0.ɵɵnextContext(); return ctx_r49.toggleRejected($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "gh-ext-infinite-list", 33);
    i0.ɵɵtemplate(7, SupplierPurchaseOrderListComponent_div_6_mat_card_7_Template, 32, 24, "mat-card", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(8);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "lbl_show_rejected"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.showRejected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("tracker", _r2)("itemHeight", 180);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ghExtInfiniteScrollForOf", ctx_r1.dataSource);
} }
var SupplierPurchaseOrderListComponent = /** @class */ (function () {
    function SupplierPurchaseOrderListComponent(businessService, notifications, waitings, route) {
        this.businessService = businessService;
        this.notifications = notifications;
        this.waitings = waitings;
        this.route = route;
        this.displayedColumns = ['deliveryDate', 'status', 'officeName', 'purchaseOrder', 'jobOrderId'];
        this.showRejected = true;
    }
    SupplierPurchaseOrderListComponent.prototype.ngOnInit = function () {
        this.subscribeToNavigation();
    };
    SupplierPurchaseOrderListComponent.prototype.getOrderId = function (index, order) {
        return order.jobOrderId;
    };
    SupplierPurchaseOrderListComponent.prototype.getRowClass = function (order) {
        return (order.statusValue || '').toLowerCase();
    };
    SupplierPurchaseOrderListComponent.prototype.isOrderPending = function (order) {
        return PurchaseOrderStatus.Pending === order.statusValue && !isNil(order.deliveryDate);
    };
    SupplierPurchaseOrderListComponent.prototype.toggleRejected = function (change) {
        this.showRejected = change.checked;
        this.loadOrders();
    };
    SupplierPurchaseOrderListComponent.prototype.reject = function (order) {
        var _this = this;
        this.businessService
            .reject(order.jobOrderId, order.version).pipe(// tslint:disable-line:no-non-null-assertion
        this.waitings.operator())
            .subscribe(function () { return _this.dataSource.fire(); }, function () { return _this.notifications.error('msg_order_changes'); });
    };
    SupplierPurchaseOrderListComponent.prototype.accept = function (order) {
        var _this = this;
        this.businessService
            .accept(order.jobOrderId, order.version).pipe(// tslint:disable-line:no-non-null-assertion
        this.waitings.operator())
            .subscribe(function () { return _this.dataSource.fire(); }, function () { return _this.notifications.error('msg_order_changes'); });
    };
    SupplierPurchaseOrderListComponent.prototype.view = function (order) {
        openInNewWindow(order.fileUrl);
    };
    SupplierPurchaseOrderListComponent.prototype.loadOrders = function () {
        var officeId = this.route.snapshot.params.officeId;
        this.dataSource = InfiniteMatDataSource.wrap(this.businessService.findAll(this.showRejected, officeId === 'all' ? void 0 : officeId));
        this.dataSource.sort = this.sort;
    };
    SupplierPurchaseOrderListComponent.prototype.subscribeToNavigation = function () {
        var _this = this;
        this.route
            .params
            .subscribe(function () { return _this.loadOrders(); });
    };
    SupplierPurchaseOrderListComponent.ɵfac = function SupplierPurchaseOrderListComponent_Factory(t) { return new (t || SupplierPurchaseOrderListComponent)(i0.ɵɵdirectiveInject(i1.SupplierPurchaseOrderListBusinessService), i0.ɵɵdirectiveInject(i2.NotificationService), i0.ɵɵdirectiveInject(i2.WaitingService), i0.ɵɵdirectiveInject(i3.ActivatedRoute)); };
    SupplierPurchaseOrderListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierPurchaseOrderListComponent, selectors: [["gh-purchase-orders"]], viewQuery: function SupplierPurchaseOrderListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        } }, decls: 9, vars: 5, consts: [[3, "title"], ["matSort", ""], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy", 4, "ghExtIfQuery"], ["fxLayout", "column", 4, "ghExtIfQuery"], ["fxFlex", ""], ["tracker", "ghExtLoadTracker"], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy"], ["matColumnDef", "deliveryDate"], ["fxFlex", "15%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "15%", 4, "matCellDef"], ["matColumnDef", "status"], ["matColumnDef", "officeName"], ["matColumnDef", "purchaseOrder"], ["fxFlex", "25%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "25%", 4, "matCellDef"], ["matColumnDef", "jobOrderId"], ["class", "cell-align-right", 4, "matHeaderCellDef"], ["class", "cell-align-right", 4, "matCellDef"], [4, "matHeaderRowDef", "matHeaderRowDefSticky"], [3, "ghExtInfiniteRow", "ngClass", 4, "matRowDef", "matRowDefColumns"], ["fxFlex", "15%", "mat-sort-header", ""], ["fxFlex", "15%"], ["fxFlex", "25%", "mat-sort-header", ""], ["fxFlex", "25%"], [1, "cell-align-right"], [1, "table-toggler", 3, "checked", "change"], ["type", "button", "class", "small cell-button", "mat-stroked-button", "", 3, "click", 4, "ngIf"], ["type", "button", "class", "small cell-button", "color", "primary", "mat-flat-button", "", 3, "click", 4, "ngIf"], ["type", "button", "mat-stroked-button", "", 1, "small", "cell-button", 3, "click"], ["type", "button", "color", "primary", "mat-flat-button", "", 1, "small", "cell-button", 3, "click"], [3, "ghExtInfiniteRow", "ngClass"], ["fxLayout", "column"], [1, "toggler"], [3, "tracker", "itemHeight"], [3, "ngClass", 4, "ghExtInfiniteScrollFor", "ghExtInfiniteScrollForOf"], [3, "ngClass"], [1, "card-content-item"], [1, "card-content-item-title"], [1, "card-content-item-value"], [1, "card-content-item-value", 3, "ngClass"]], template: function SupplierPurchaseOrderListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content");
            i0.ɵɵelementContainerStart(4, 1);
            i0.ɵɵtemplate(5, SupplierPurchaseOrderListComponent_mat_table_5_Template, 18, 6, "mat-table", 2);
            i0.ɵɵtemplate(6, SupplierPurchaseOrderListComponent_div_6_Template, 8, 7, "div", 3);
            i0.ɵɵelement(7, "gh-ext-load-tracker", 4, 5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "lbl_purchase_orders"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ghExtIfQuery", "gt-sm");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ghExtIfQuery", "lt-md");
        } }, directives: [i4.ExtPageComponent, i4.ExtPageTitleDirective, i4.ExtPageContentComponent, i5.MatSort, i6.ExtIfQueryDirective, i7.ExtLoadTrackerComponent, i8.DefaultFlexDirective, i9.MatTable, i10.ExtInfiniteTableDirective, i11.ExtInfiniteTableViewerDirective, i9.MatColumnDef, i9.MatHeaderCellDef, i9.MatCellDef, i9.MatHeaderRowDef, i9.MatRowDef, i9.MatHeaderCell, i5.MatSortHeader, i9.MatCell, i12.MatSlideToggle, i13.NgIf, i14.MatButton, i9.MatHeaderRow, i9.MatRow, i15.ExtInfiniteRowDirective, i13.NgClass, i16.DefaultClassDirective, i8.DefaultLayoutDirective, i17.ExtInfiniteListComponent, i18.ExtInfiniteScrollForDirective, i19.MatCard, i19.MatCardContent, i19.MatCardActions], pipes: [i20.TranslatePipe, i21.TypeFormatPipe], styles: ["[_nghost-%COMP%]     .rejected .mat-cell {\n  color: #b7022f; }\n\n[_nghost-%COMP%]     .accepted .mat-column-status {\n  color: #009d0c; }\n\n[_nghost-%COMP%]     .mat-card .rejected, [_nghost-%COMP%]     .mat-card.rejected {\n  border-color: #b7022f; }\n\n[_nghost-%COMP%]     .mat-card .accepted, [_nghost-%COMP%]     .mat-card.accepted {\n  border-color: #009d0c; }\n\n[_nghost-%COMP%]     .card-content-item-value.accepted {\n  color: #009d0c; }\n\n[_nghost-%COMP%]     .card-content-item-value.rejected {\n  color: #b7022f; }\n\n[_nghost-%COMP%]     .toggler {\n  margin: 17px 12px; }"] });
    return SupplierPurchaseOrderListComponent;
}());
export { SupplierPurchaseOrderListComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierPurchaseOrderListComponent, [{
        type: Component,
        args: [{
                selector: 'gh-purchase-orders',
                templateUrl: 'supplier-purchase-order-list.component.html',
                styleUrls: ['./supplier-purchase-order-list.component.scss'],
            }]
    }], function () { return [{ type: i1.SupplierPurchaseOrderListBusinessService }, { type: i2.NotificationService }, { type: i2.WaitingService }, { type: i3.ActivatedRoute }]; }, { sort: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }] }); })();
